import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Typeahead, TimePicker,
    cellEditFactory ,moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, Container, Modal, DatePicker,Dropdown, DropdownButton, props, sizePerPageRenderer
} 
from '../../noser-hris-component';

import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import { Image} from 'react-bootstrap';
import { BsFileEarmarkPlus } from "react-icons/bs";
import { resolve } from 'q';



class AttachmentModal extends Component {
    constructor(props) {
        super(props)
        this.state ={
            userinfo        :   [],
            
            isloading       :   false,
            isshow          :   false,
            alerttype       :   "",
            message         :   "",
            color           :   "",
            fade            :   true,

            caseData        : [],
            shown                   :"",
            replyId                 :[],
            newCaseId       :   '',
            userId          : "",
            userFirstName   : "",
            roleId          : "",
            Attachment      : false,
            ReplyAttachment : false,


            getShipTo           :   "",
            unKnownData         :   [],
            viewConcernDataInfo :   [],
            caseReplyList       :   [],

        }
    }
    componentDidMount = async() =>{
       this.state.userinfo = JSON.parse(sessionStorage.getItem("userData")) 
       console.log(this.state.userinfo)
       let employeeIdtmp = this.state.userinfo.employeeId

       this.state.viewConcernDataInfo = JSON.parse(sessionStorage.getItem("viewConcernData"))
       //console.log(this.state.viewConcernDataInfo)
       
       
       const sleep = (milliseconds) => {return new Promise(resolve => setTimeout(resolve, milliseconds))}
       this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
       //console.log(this.props.location.params.data)
       this.setState({
           userId: this.state.userinfo.userId,
           userFirstName: this.state.userinfo.firstName,
           roleId: this.state.userinfo.roleId
       })
       
       this.Attachment();
    };

    onModalClose = () => {
        this.props.onHide("Hello Parent! It's your turn parent"); 
        this.setState({isshow: false,})
        //this.componentDidMount();
    };
    Attachment = async() => {
        let newId = this.state.viewConcernDataInfo.id
        console.log(newId)
        console.log("newId")

        if(newId == "concernId" || newId === "concernId" ){
            console.log("equals")
        } else {
            console.log("undefined asdfg")
        }
       
       //console.log(this.state.caseId)
        let filter_data ={ "concernId": newId }  

        const getParams ={
            "dbname"        :   "CUSTOMERSERVICEUAT",
        "_collection" : "ImageCase",
        "filter_data" : filter_data
        }
        //console.log("1")
        axios
        .post(AppConfiguration.Setting().noserCSDB + "action/get" , getParams)
        .then(res =>{
            let data = res.data
            //console.log("2")
            const itemUsersDataLists = this.buildListImage(data["ResultList"])
            
            this.state.itemUserDataList  =  itemUsersDataLists
            let List =[]
            //console.log("3")
            for (let i = 0; i < this.state.itemUserDataList.length; i++) {
                //console.log(this.state.itemUserDataList[i])
                //console.log("this.state.itemUserDataList")
                let obj = {
                    
                    'image'         :   this.state.itemUserDataList[i]
                    
                }

                this.setState({
                    image           : obj.image,
                })

            }
        })
        .catch(error=>{
            console.log("error: " + error)
        })
    } 

    buildListImage =(data)=>{
        let itemList =[]
        for (let i = 0; i < data.length; i++) {
            let s1 = data[i].split(", ")
            let s2 = s1[1].split("'image':")
            let s3 = s2[1].split(", ")
            let s4 = s3[0].replace("'","").replace("'","")

            itemList.push(s4)  
            //console.log(itemList)
            //console.log("itemList before loop")

            for (let x =1; x < s3.length; x++) {
                    
                itemList.push(s3[x])

            }

            //console.log(itemList)
            //console.log("itemList  loop")
        }
        //console.log("return buildlist")
        return itemList
    }
    render() {
        return(
        
            <Modal
                {...this.props}
                return
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                className="modal-90w"
                 >
                <Modal.Header closeButton className="card-header">
                    <Modal.Title id="contained-modal-title-vcenter">
                        Attachment
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Form>
                            <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                                <div className={this.state.color}></div> 
                                {this.state.message}
                            </Alert>
                            <div style={{height: '450px', overflowY: 'scroll',whiteSpace: 'nowrap' }}>
                                <Form.Group as={Row} controlId="formPlaintextEmail">
                                    <Form.Label column sm="12" style={{fontWeight : "bold"}}>
                                    <Image src = {`data:image/jpeg;base64,${this.state.image}`} style={{width: '400px', height: '400px'}}/>
                                    </Form.Label>
                                </Form.Group>
                            </div>
                        </Form>
                    </Container>
                </Modal.Body>
                <NoserLoading show={this.state.isloading} />
            </Modal>
        );
    }

}
export  default AttachmentModal